import React, { FC } from 'react'

import loadable from '@loadable/component'
import { useParams } from 'react-router'

import { profileOperation } from 'api/clientStatisticApi'
import { BannerId, BannerPlaces } from 'components/banner/banner.constants'
import { GenericBanner } from 'components/banner/GenericBanner'
import { BannerLoadable as FeedProfileBanner } from 'components/banner/Profile/Feed/BannerLoadable'
import { BannerLoadable as TopProfileBanner } from 'components/banner/Profile/Top/BannerLoadable'
import { ProfileHeader } from 'components/page/Profile/ProfileHeader/ProfileHeader'
import { ProfileLoadable } from 'components/page/Profile/ProfileLoadable'
import { UserProfileLayout } from 'components/page/UserProfile/UserProfileLayout'
import { ProfileRouteParams } from 'components/paths'
import { ErrorBoundary } from 'components/system/ErrorBoundary'
import { PerformanceStart } from 'components/system/statistic/PerfomanceStart'
import { useIsCurrentUser } from 'hooks/useIsCurrentUser'
import { useIsMobileView } from 'hooks/useIsMobileView'
import { useRedesignLayout } from 'hooks/useRedesign'
import { useReducersInsert } from 'hooks/useReducersInsert'
import { profileReducer } from 'reducers/profile/profileReducer'

export const ForeignProfileLoadable = loadable(
  async () =>
    (await import('components/page/ForeignProfile/ForeignProfile'))
      .ForeignProfile
)

const ProfileSwitch: FC = () => {
  useReducersInsert({
    profile: profileReducer,
  })
  const { userId } = useParams<ProfileRouteParams>()
  const isCurrentUser = useIsCurrentUser(userId)
  const isMobile = useIsMobileView()
  const redesignLayout = useRedesignLayout()

  if (isCurrentUser) {
    return (
      <ErrorBoundary place="current-profile">
        <UserProfileLayout>
          <PerformanceStart operation={profileOperation} />
          {!redesignLayout && <ProfileHeader />}
          <GenericBanner
            place={BannerPlaces.topProfileBanner}
            banner={<TopProfileBanner bannerId={BannerId.topProfileBanner} />}
          />
          <ProfileLoadable />
          {!isMobile && (
            <GenericBanner
              place={BannerPlaces.feedProfileBanner}
              banner={
                <FeedProfileBanner bannerId={BannerId.feedProfileBanner} />
              }
            />
          )}
        </UserProfileLayout>
      </ErrorBoundary>
    )
  }

  /**
   * https://youtrack.mamba.ru/issue/M-11581
   * Временно убираем на мобильных баннер с рекламой с чужого профиля
   */
  if (isMobile) {
    return (
      <ErrorBoundary place="foreign-profile">
        <UserProfileLayout>
          <PerformanceStart operation={profileOperation} />
          <ForeignProfileLoadable />
        </UserProfileLayout>
      </ErrorBoundary>
    )
  }

  return (
    <ErrorBoundary place="foreign-profile">
      <UserProfileLayout>
        <PerformanceStart operation={profileOperation} />
        <GenericBanner
          place={BannerPlaces.topProfileBanner}
          banner={<TopProfileBanner bannerId={BannerId.topProfileBanner} />}
        />
        <ForeignProfileLoadable />
      </UserProfileLayout>
    </ErrorBoundary>
  )
}

export default ProfileSwitch
